import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { ConstantService } from "../../../../components/common/utils/constant.service";
import { ClienteLogin, Cliente, ClienteXCiudad } from "../../../login/cliente_login";
import { ContragarantiasEntity } from "./../entities/contragarantias_entity";
import { Headers, Http, Response, RequestOptions } from '@angular/http';


declare var jQuery: any;

@Injectable()
export class ContragarantiasService {
    usuario: ClienteLogin;
    userEmpresa: ClienteXCiudad;
    private url = "contragarantias";

    constructor(public authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    consultarListaContragarantias(userEmpresa:ClienteXCiudad): Observable<ContragarantiasEntity[]> {        
        let body = JSON.stringify(userEmpresa);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultaListaContragarantias", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }

}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/fianzas/contragarantias/contragarantias.service.ts